import Api from 'api';

import {
  GET_PROVIDERS,
  SET_PROVIDERS_PAGINATION,
  SET_PROVIDERS_FILTERS,
  RESET_PROVIDERS,
  TOGGLE_PROVIDER,
  ADD_PROVIDER,
  UPDATE_PROVIDER,
  GET_PROVIDER_BY_ID,
  RESET_PROVIDER_FORM,
  MODIFY_CUSTOM_FIELD_EDITING_PROVIDER, //Groups
  MODIFY_EDITING_PROVIDER,
} from 'providers/constants';

export const setPagination = (payload) => ({
  type: SET_PROVIDERS_PAGINATION,
  payload,
});

export const setFilters = (payload) => ({
  type: SET_PROVIDERS_FILTERS,
  payload,
});

export const getProviders = (companyId, subcompanyId, filters, limit, page, orderBy, order) => ({
  type: GET_PROVIDERS,
  payload: Api.providers.get(companyId, subcompanyId, filters, limit, page, orderBy, order),
});

export const reset = () => ({ type: RESET_PROVIDERS });

export const toggleProvider = (providerId, companyId, subcompanyId) => ({
  type: TOGGLE_PROVIDER,
  meta: { id: providerId },
  payload: Api.providers.toggle(providerId, companyId, subcompanyId),
});

export const resetForm = () => ({ type: RESET_PROVIDER_FORM });

export const getProviderById = (providerId, companyId, subcompanyId) => ({
  type: GET_PROVIDER_BY_ID,
  meta: { needAuth: true },
  payload: Api.providers.getById(providerId, companyId, subcompanyId),
});

export const modifyProvider = (payload) => ({ type: MODIFY_EDITING_PROVIDER, payload });

//Groups
export const modifyCustomField = (payload) => ({
  type: MODIFY_CUSTOM_FIELD_EDITING_PROVIDER,
  payload,
}); // Agregado

export const addProvider = (companyId, subcompanyId, provider) => ({
  type: ADD_PROVIDER,
  payload: Api.providers.add(companyId, subcompanyId, provider),
});

export const updateProvider = (providerId, companyId, subcompanyId, provider) => ({
  type: UPDATE_PROVIDER,
  meta: { id: providerId, needAuth: true },
  payload: Api.providers.update(providerId, companyId, subcompanyId, provider),
});



// WEBPACK FOOTER //
// src/modules/secured/modules/providers/actions/providers_actions.js